const info = [
    {
        name:"layerMore1",
        el:"#layer-more1",
        btn:".privacy__more--1",
    },
    {
        name:"layerMore2",
        el:"#layer-more2",
        btn:".privacy__more--2",
    },
    {
        name:"layerConfirm",
        el:"#layer-confirm",
        btn:".sec-2__pet--btn--confirm",
    }
];

export default info;


// WEBPACK FOOTER //
// ./src/js/layer-info.js